<template>
    <a
        v-bind="$attrs"
        class="search-result-ticket"
        :data-bot="context ? `search-result__ticket--${context}` : 'search-result__ticket'"
        :class="classes"
        :href="link"
        @mouseenter="handleMouseEnter"
        @mouseleave="isHovered = false"
    >
        <CompassObject size="extra-small" type="object" object="support-emoji" />
        <div class="search-result-ticket__content">
            <div class="search-result-ticket__title">
                <h5
                    class="search-result-ticket__name typographies-paragraph-medium-bold"
                    v-html="subject"
                />
                <div v-if="status" class="ticket-status">
                    <CompassTag
                        size="small"
                        :color="statusInformation.color"
                        :icon="statusInformation.icon"
                    >
                        {{ status.label }}
                    </CompassTag>
                </div>
            </div>
            <p class="search-result-ticket__third">
                <span class="typographies-paragraph-medium-regular" v-html="id" />
                <span
                    v-if="third !== ''"
                    class="typographies-paragraph-medium-semibold search-result-ticket__company"
                    v-html="third"
                />
            </p>
        </div>
    </a>
</template>
<script>
import { allStatus } from 'Dictionaries/statusColors';
import SearchResultsGeneric from './SearchResultsGeneric.vue';

export default {
    extends: SearchResultsGeneric,
    props: {
        id: {
            type: String,
            required: true,
        },
        third: {
            type: String,
            default: '',
        },
        subject: {
            type: String,
            required: true,
        },
        status: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        statusInformation() {
            return allStatus[this.status.id];
        },
        classes() {
            return {
                'search-result-ticket--is-hovered': this.isHovered,
            };
        },
    },
};
</script>
<style lang="scss" scoped>
.search-result-ticket {
    align-items: flex-start;
    cursor: pointer;
    display: flex;
    gap: var(--spacing-1);
    padding: var(--spacing-1) var(--spacing-3);

    &--is-hovered {
        background: var(--colors-common-background-hover, #f6f6f9);
    }

    &__title {
        align-items: center;
        display: flex;
        gap: var(--spacing-1);
    }

    .ticket-status {
        color: var(--colors-common-text-standard-default, #111);
    }

    &__name {
        color: var(--colors-common-text-standard-default, #111);
        margin: 0;
    }

    &__third {
        color: var(--colors-common-text-subtle-default, #565665);
        display: flex;
        gap: var(--spacing-2);
        margin: var(--spacing-0) 0 0;
    }

    &__company {
        flex-shrink: 0;
        max-width: 220px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    :deep(.highlight) {
        background: var(--colors-common-background-highlight-search);
    }
}
</style>
